import { useSWRFetch } from '@hooks/useSWRFetch';

// Backend contract: atlas-view SearchService.HasMusicVideoAccess
// Proto: services-pilot/atlas/atlas-view/src/main/proto/v2/search.proto
type HasMusicVideoAccessResponse = {
  hasAccess: boolean;
};

export type UseHasMusicVideoAccessResult = {
  hasAccess: boolean;
  isLoading: boolean;
};

const requestObject = { url: 'v3/hasMusicVideoAccess' };

// Entitlement is stable within a browser-tab session; cache for the lifetime
// of the tab to avoid redundant requests. Access is authoritatively enforced
// server-side, so this is a UX cache, not a security boundary.
export const useHasMusicVideoAccess = (): UseHasMusicVideoAccessResult => {
  const { data, isLoading } = useSWRFetch<HasMusicVideoAccessResponse>(
    requestObject,
    {
      dedupingInterval: Number.MAX_SAFE_INTEGER,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return {
    hasAccess: data?.hasAccess ?? false,
    isLoading,
  };
};
